export default __webpack_public_path__ + "static/media/Prispek Privacy Note.073c9686.pdf";